(() => {
  'use strict';

  // Keep Vitals' own button and handlers; never simulate a successful add.
  const anchorSelector = '.lb-wishlist-anchor';
  const wrapperSelector = '.Vtl-WishlistButtonWrapper';
  const controlSelector = '.Vtl-WishlistButton__AddToWishlist';
  let preserved = null;
  let productId = null;
  let scheduled = false;
  let notifiedVariant = null;
  let deadline = Date.now() + 15000;

  const sync = () => {
    scheduled = false;
    const anchor = document.querySelector(anchorSelector);
    if (!anchor) return;
    if (productId !== anchor.dataset.productId) {
      preserved = null;
      productId = anchor.dataset.productId;
      deadline = Date.now() + 15000;
    }
    const area = anchor.closest('.product__submit__buttons');
    const candidates = Array.from(area.querySelectorAll(wrapperSelector))
      .filter(node => node.querySelector(controlSelector));
    // Prefer a fresh app render with current variant handlers. Restore the
    // preserved node only during a theme morph, without cloning its handlers.
    const fresh = candidates.find(node => !anchor.contains(node));
    const next = fresh || candidates[0] || preserved;
    observer.disconnect();
    if (next && next.querySelector(controlSelector)) {
      if (preserved && preserved !== next) preserved.remove();
      preserved = next;
      preserved.setAttribute('data-lb-wishlist-stable', 'true');
      if (preserved.parentElement !== anchor) anchor.appendChild(preserved);
      candidates.forEach(node => { if (node !== preserved) node.remove(); });
      anchor.setAttribute('data-lb-wishlist-ready', 'true');
    } else {
      anchor.removeAttribute('data-lb-wishlist-ready');
      const button = anchor.querySelector('[data-lb-wishlist-fallback-add]');
      const label = button?.querySelector('span');
      const expired = Date.now() >= deadline;
      if (button && label) {
        button.disabled = !expired;
        button.setAttribute('aria-busy', String(!expired));
        label.textContent = expired ? anchor.dataset.retryLabel : anchor.dataset.loadingLabel;
      }
    }
    observer.observe(document.body, { childList: true, subtree: true });
    // Vitals supports delegated change events on .swatch__item. Pipeline's
    // selectors sit outside the add-to-cart form and its input can be morphed.
    // Mark the real option labels for that supported DOM integration.
    document.querySelectorAll('.product__block__variants label[for]').forEach(label => {
      label.classList.add('swatch__item');
    });
    const variantId = new URL(window.location.href).searchParams.get('variant');
    const selected = document.querySelector('.product__block__variants input[type="radio"]:checked');
    const label = selected?.labels?.[0];
    if (variantId && variantId !== notifiedVariant && label) {
      notifiedVariant = variantId;
      label.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  };
  const observer = new MutationObserver(schedule);
  const start = () => {
    document.addEventListener('click', event => {
      const retry = event.target.closest('[data-lb-wishlist-fallback-add]');
      if (retry && !retry.disabled) window.location.reload();
    });
    schedule();
    setTimeout(schedule, 15100);
    window.addEventListener('theme:section:update', schedule);
    window.addEventListener('vitals:AppInit', schedule);
    window.addEventListener('vitals:RenderWishlistButton', schedule);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else start();
})();
